import React from 'react';

import { type ModelType } from 'app/main/components/hooks/useModel';
import useSettings from 'app/main/components/hooks/useSettings';
import Icon from 'app/main/components/Icon';
import UploadFile from 'app/main/components/fields/UploadFile';
import DetailsSectionWrapper from '../components/DetailsSectionWrapper';

interface DetailsSectionImageProps {
	title: React.ReactNode;
	subheader: React.ReactNode;
	isEdit?: boolean;
	fieldName: string;
	fileName: string;
	path: string;
	value?: string;
	grabberProps?: { defaultSearch?: string };
	sendChange: ModelType['sendFilesChange'];
}

export default function DetailsSectionImage(props: DetailsSectionImageProps) {
	const { t } = useSettings();

	return (
		<DetailsSectionWrapper avatar={<Icon icon="image" />} title={props.title} subheader={props.subheader}>
			{props.isEdit ? (
				<UploadFile
					fieldName={props.fieldName}
					fileName={props.fileName}
					path={props.path}
					value={props.value}
					grabberProps={props.grabberProps}
					sendChange={props.sendChange}
				/>
			) : props.value ? (
				<img
					className="w-full"
					src={`${import.meta.env.VITE_ENDPOINT}/resources/${props.path}/${props.value}?v=${Date.now()}`}
					alt={props.value}
				/>
			) : (
				<i>{t('NO_FILE_UPLOADED')}</i>
			)}
		</DetailsSectionWrapper>
	);
}
